import * as tslib_1 from "tslib";
import axios from 'axios';
import API_BASE from '@/services/config';
const zhugeAxios = axios.create({
    baseURL: API_BASE.zhuge,
});
export function requestPostFactory(url, args, options = {}, justResp = false) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const resp = yield zhugeAxios.post(`/mainPage/${url}.json`, args, Object.assign({ withCredentials: true }, options));
        return justResp ? resp : resp.data.data;
    });
}
// 获取首页数据
export function getMainPage(args) {
    return requestPostFactory('getMainPage', args);
}
// 获取详情页顶部数据
export function getSceneTopInfo(args) {
    return requestPostFactory('getSceneTopInfo', args);
}
// 获取二级页面描述和版本信息
export function getSceneDesc(args) {
    return requestPostFactory('getSceneDesc', args);
}
// 获取数据效果展示
export function getDataDemos(args) {
    // return requestPostFactory('getDataDemos', args);
    return requestPostFactory('getDataDemosV2', args);
}
// 下载数据
export function exportData(args) {
    return requestPostFactory('exportData', args, { responseType: 'blob' }, true);
}
